import { createSlice } from '@reduxjs/toolkit';
import { ISupplier } from '../../../../dto';
import { setSupplier } from '../actions';
import { MN_SUPPLIERS, TYPE_ELEMENT } from '../../../../common';

export interface SupplierState {
  data: ISupplier | null;
  loading: boolean;
  error: string | null;
}

const initialState: SupplierState = {
  data: null,
  loading: false,
  error: null,
};

export const supplierSlice = createSlice({
  name: `${MN_SUPPLIERS}/${TYPE_ELEMENT}`,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setSupplier, (state, { payload }) => {
      state.data = payload;
    });
  },
});
